import React from 'react'
import './CardSkeletonLoader.css';

const getCardStyle = (count, index) => {
  const rowSize = 4;
  const rowIndex = Math.floor(index / rowSize);
  const lastRowIndex = Math.floor((count - 1) / rowSize);
  const itemsInLastRow = count % rowSize || rowSize;

  if (rowIndex < lastRowIndex) {
    // Full rows → fixed 25%
    return { flex: '0 0 calc((100% - 3rem) / 4)' }; // 3 gaps between 4 cards (gap: 1rem)
  } else {
    // Last row → divide equally based on how many cards are in this row
    const totalGap = (itemsInLastRow - 1) * 16; // 1rem = 16px
    return {
      flex: `0 0 calc((100% - ${totalGap}px) / ${itemsInLastRow})`,
    };
  }
};

const CardSkeletonLoader = ({ count = 3 }) => {
  return (
    <div className="card-loader-flex-container">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          data-testid={`card-loader-${i}`}  
          className="metric-card-loader"
          style={getCardStyle(count, i)}
        >
          <div className="circle-icon-placeholder" />
          <div className="metric-line" />
          <div className="button-placeholder" />
        </div>
      ))}
    </div>
  );
};

export default CardSkeletonLoader
